import {Injectable} from '@angular/core';
import {Actions, Effect, ofType} from '@ngrx/effects';
import {catchError, switchMap} from 'rxjs/operators';
import {of} from 'rxjs';
import {LoadError} from '@app/core/store/actions/error.actions';
import {EPayrollsActions, GetPayrollDetails, GetPayrollDetailsSuccess, GetPayrolls, GetPayrollsSuccess,} from '@app/core/store/actions/payrolls.actions';
import {Payroll} from '@app/core/models/payroll.model';
import {PaginationHolder} from '@app/core/models/pagination.model';
import {PayrollService} from '@app/core/services/api/payroll.service';

@Injectable()
export class PayrollEffects {

	@Effect()
	public onGetPayrolls$ = this.actions$.pipe(
		ofType<GetPayrolls>(EPayrollsActions.GetPayrolls),
		switchMap((action: GetPayrolls) => this.payrollService.getPayrolls(action.page, action.pageSize, action.searchQuery).pipe(
			switchMap((ph: PaginationHolder<Payroll>) => [
				new GetPayrollsSuccess(ph),
			]),
			catchError(error => of(new LoadError(error, action))),
		)),
	);

	@Effect()
	public onGetPayrollDetails$ = this.actions$.pipe(
		ofType<GetPayrollDetails>(EPayrollsActions.GetPayrollDetails),
		switchMap((action: GetPayrollDetails) => this.payrollService.getPayroll(action.payrollId).pipe(
			switchMap((payroll: Payroll) => [
				new GetPayrollDetailsSuccess(payroll),
				/*new GetPayrollTags(action.payrollId),
				 new GetPayrollNotes(action.payrollId),
				 new GetPayrollBookings(action.payrollId),*/
			]),
			catchError(error => of(new LoadError(error, action))),
		)),
	);

	constructor(
		private payrollService: PayrollService,
		private actions$: Actions,
	) {
	}
}
